import React, { Fragment, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import VideoPlayer from "react-video-js-player";

import { streamLive, streamNotLive } from "../../../actions/stream";

import { evaluate } from "../../../utilities/props";

const StreamerVideo = ({
  profile,
  time,
  videoduration,
  showChat,
  descriptionObject,
  viewerCount,
  streamLive,
  streamNotLive,
  setIsError,
}) => {
  time = evaluate(time);
  videoduration = evaluate(videoduration);
  const playerRef = useRef(null);
  const [error, setError] = useState(null);

  const handlePlayerReady = (player) => {
    player.on("error", (event) => {
      setError(event);
    });
  };

  useEffect(() => {
    if (error && error.type === "error") {
      return setIsError(true);
    } else {
      return setIsError(false);
    }
  }, [error]);

  return (
    <Fragment>
      <div className="live-stream-video-landing-container grey" ref={playerRef}>
        <div className="">
          <div className="user-overlay-info">
            <div className="avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                className="streamer-user-avi"
              />
            </div>
            <div className="helper-container">
              <div className="stream-description-alt">
                <p className="stream-username-title">
                  <span className="red mr-5 description-font">
                    {profile.channelid}
                  </span>
                  <span className="white description-font-alt">
                    {profile.jobtitle}
                  </span>
                </p>
                {descriptionObject.updatedDescription &&
                  descriptionObject.updatedDescription !== "" && (
                    <p className="stream-p-description">
                      {descriptionObject.updatedDescription}
                    </p>
                  )}
                <div className="viewers">
                  <i className="fas fa-user action-icon-user mr-5 red"></i>
                  <span className="white bold">Viewers</span>{" "}
                  <span className="white bold mx-5">
                    {viewerCount && viewerCount.length}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              showChat ? "video-stream-live red" : "video-stream-live-chat red"
            }
          >
            <i className="fas fa-circle mx-5"></i>
            Re-run
          </div>
          <div className="icon-flex-expand-settings"></div>
        </div>
        <VideoPlayer
          className="fill-video translate-video"
          src={"https://stream.imelive.tv/obs_stream.m3u8"}
          controls
          onReady={handlePlayerReady}
        />
      </div>
    </Fragment>
  );
};

StreamerVideo.propTypes = {
  className: PropTypes.string,
};

const mapStateToProps = (state) => ({
  stream: state.stream,
});

export default connect(mapStateToProps, { streamLive, streamNotLive })(
  StreamerVideo,
);
